import { isDefined } from '@grandvisionhq/utils';

// Convert from the Graph key to the CommerceTools key or Analytics key.
const specificationDictionary = {
    accessoryColor: 'accessoryColor',
    accessoryColorUnlocalized: 'accessoryColorUnlocalized',
    accessoryTypeUnlocalized: 'accessoryTypeUnlocalized',
    accessoryType: 'accessoryType',
    articleNumber: 'articleNumber',
    brand: 'brand',
    erpId: 'erpId',
    faceShape: 'faceShape',
    frameColor: 'frameColor',
    frameColorUnlocalized: 'frameColorUnlocalized',
    frameMaterial: 'frameMaterial',
    frameMaterialUnlocalized: 'frameMaterialUnlocalized',
    frameShape: 'frameShape',
    frameShapeUnlocalized: 'frameShapeUnlocalized',
    frameType: 'frameType',
    frameTypeUnlocalized: 'frameTypeUnlocalized',
    frameSize: 'frameSize',
    isGlazeble: 'glazeble',
    lensColor: 'lensColor',
    opcoBackendId: 'opcoBackendId',
    isPolarized: 'polarized',
    prescriptionGlass: 'prescriptionGlass',
    roadworthiness: 'roadworthiness',
    supplierEAN: 'supplierEAN',
    targetGender: 'gender',
    genderUnlocalized: 'genderUnlocalized',
    templeType: 'templeType',
    trend: 'trend',
    segment: 'segment',
    material: 'material',
    materialUnlocalized: 'materialUnlocalized',
    sku: 'sku',
    brandModelCode: 'brandModelCode',
    // Contact Lens specifications
    hasUvProtection: 'features.uv',
    lensType: 'lensType',
    lensTypeUnlocalized: 'lensTypeUnlocalized',
    materialType: 'materialType',
    packageQuantity: 'packageQuantity',
    waterContent: 'waterContent',
    replacementFrequency: 'replacementFrequency',
    replacementFrequencyUnlocalized: 'replacementFrequencyUnlocalized',
    // Solutions specifications
    lensTypeTarget: 'lensTypeTarget',
    caseIncluded: 'caseIncluded',
    minimumCycleTime: 'minimumCycleTime',
    preservativeFree: 'preservativeFree',
    maxTimeFrameInLensCase: 'maxTimeFrameInLensCase',
    expirationAfterOpening: 'expirationAfterOpening'
};
const getSpecificationItems = (serverSpecifications)=>{
    const clientSpecifications = Object.entries(serverSpecifications).map(([graphKey, value])=>{
        const specificationAttribute = specificationDictionary[graphKey];
        if (!specificationAttribute || value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0) {
            return undefined;
        }
        return {
            specificationAttribute,
            value
        };
    });
    return clientSpecifications.filter(isDefined);
};

export { getSpecificationItems };
//# sourceMappingURL=get-specification-items.js.map
